import React from 'react'

export default () => (
  <div className="text-center">
    <span className="mr-3">TEL：0120-507-765</span>
    <span>メール：</span>
    <a href="mailto:tb-customer-success@hacobell.co.jp">tb-customer-success@hacobell.co.jp</a>
  </div>
)
